import React, { useState } from "react"
import firebase from "gatsby-plugin-firebase"

import styles from "../styles/logpage.module.css"

export default () => {
    //email password variables
    const [email,setEmail] = useState("")
    const [password,setPassword] = useState("")
    //sends the request
    const SignIn = (email,password) =>{
        firebase.auth().signInWithEmailAndPassword(email, password).catch(e => {
            alert(e.message)
          })
        console.log(email,password)
    }
    return(
        <form className = {styles.form} onSubmit = {(e)=>{
            e.preventDefault()
            SignIn(email,password)
        }}>
            <input className = {styles.input} type = "text" placeholder = "Email" onChange = {(e)=>setEmail(e.target.value)}/>
            <input className = {styles.input} type = "password" placeholder = "Password" onChange = {(e)=>setPassword(e.target.value)}/>
            <input className = {styles.button} type = "submit" value = "Sign In"/>
        </form>
    )
}